export default __webpack_public_path__ + "static/media/siluetaPet.7c35406e.jpg";